import React, { createContext, useContext, useEffect, useState } from "react";
import api, { apiError } from "@/lib/api";

const AuthContext = createContext(null);
const TOKEN_KEY = "somcore_token";
const ADMIN_TOKEN_KEY = "somcore_admin_token";

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null=checking, false=unauth, obj=auth
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem(TOKEN_KEY);
    if (!token) {
      setUser(false);
      setLoading(false);
      return;
    }
    api.get("/auth/me")
      .then((r) => setUser(r.data))
      .catch(() => { localStorage.removeItem(TOKEN_KEY); setUser(false); })
      .finally(() => setLoading(false));
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem(TOKEN_KEY, data.token);
    setUser(data.user);
  };

  const logout = () => {
    localStorage.removeItem(TOKEN_KEY);
    localStorage.removeItem(ADMIN_TOKEN_KEY);
    setUser(false);
    window.location.href = "/login";
  };

  const impersonate = async (userId) => {
    const { data } = await api.post(`/users/${userId}/impersonate`);
    localStorage.setItem(ADMIN_TOKEN_KEY, localStorage.getItem(TOKEN_KEY));
    localStorage.setItem(TOKEN_KEY, data.token);
    window.location.href = "/";
  };

  const returnToAdmin = () => {
    const adminToken = localStorage.getItem(ADMIN_TOKEN_KEY);
    if (adminToken) {
      localStorage.setItem(TOKEN_KEY, adminToken);
      localStorage.removeItem(ADMIN_TOKEN_KEY);
    }
    window.location.href = "/team";
  };

  const refreshUser = async () => {
    const { data } = await api.get("/auth/me");
    setUser(data);
    return data;
  };

  const isImpersonating = !!localStorage.getItem(ADMIN_TOKEN_KEY);

  return (
    <AuthContext.Provider value={{ user, loading, login, logout, impersonate, returnToAdmin, isImpersonating, refreshUser }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
export { apiError };
